import { useState, useEffect, useRef } from 'react';

const words = ['Meetups', 'Discussions', 'Meetings', 'School', 'Ideas'];

export default function LandingHeaderAnimation() {
  const [index, setIndex] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);
  const measureRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 3500);

    return () => clearInterval(interval);
  }, []);

  // Calculate the maximum width needed for all words
  useEffect(() => {
    if (measureRef.current) {
      let maxWidth = 0;
      words.forEach(word => {
        measureRef.current.textContent = word;
        maxWidth = Math.max(maxWidth, measureRef.current.offsetWidth);
      });
      setContainerWidth(maxWidth);
    }
  }, []);

  return (
    <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mt-8 sm:mt-16 md:mt-24 px-4 max-w-4xl mx-auto">
      <div className="flex flex-col items-center justify-center">
        <span className="whitespace-nowrap mb-2">AI Summarization for</span>
        <span 
          className="inline-block relative h-[1.2em] flex items-center justify-center"
          style={{ minWidth: containerWidth || 'auto' }}
        >
          {words.map((word, i) => (
            <span
              key={i}
              className={`absolute inset-0 flex text-6xl mt-2 items-center justify-center transition-all duration-500 ease-in-out whitespace-nowrap text-blue-600
                ${i === index ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'}`}
            >
              {word}
            </span>
          ))}
        </span>
      </div>
      
      {/* Hidden element for measuring text width */}
      <span 
        ref={measureRef}
        className="absolute invisible text-2xl sm:text-3xl md:text-4xl font-bold text-blue-600 whitespace-nowrap"
        aria-hidden="true"
      />
    </div>
  );
}